// =========================================================
// ACHTUNG - Source ist generiert!!! (2023-07-03T08:35:59.548Z)
// von csv-to-ts-fragen-block-gen.ts
// ---------------------------------------------------------

import { IRollenFeatures, ITarifFeature } from './antrag-fragen';

export interface ILvDefinitionen {
  tarife: { [tarifNr: string]: ITarifFeature };
  rollen: { [rolle: string]: IRollenFeatures };
}

export const lvTarifFeatures: ITarifFeature[] = [
  {
    tarifNr: '1002',
    kurzBez: 'EPGK/5',
    bez: 'EPGK/5   Kollektiv-Pflegeversicherung, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1003',
    kurzBez: 'EPG/5',
    bez: 'EPG/5   Pflegeversicherung, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1004',
    kurzBez: 'EPGP/5',
    bez: 'EPGP/5   Privatplan Meine Zukunft, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1005',
    kurzBez: 'EPGPV/5',
    bez: 'EPGPV/5   Privatplan Meine Zukunft mit abgekürzter Prämienzahlungsdauer, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1014',
    kurzBez: 'EPLK3/5',
    bez: 'EPLK3/5   Erlebensversicherung § 3(1) Z15a, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1019',
    kurzBez: 'ER/5',
    bez: 'ER/5   Risikoversicherung, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1025',
    kurzBez: 'EBTE/5',
    bez: 'EBTE/5   Bestattungsvorsorge gegen Einmalerlag, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1034',
    kurzBez: 'VEG/5',
    bez: 'VEG/5, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1036',
    kurzBez: 'VEV/5',
    bez: 'VEV/5, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1039',
    kurzBez: 'VEGE/5',
    bez: 'VEGE/5, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1040',
    kurzBez: 'EG/5',
    bez: 'EG/5   Kapitalversicherung auf Er- u. Ableben, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1041',
    kurzBez: 'EGV/5',
    bez: 'EGV/5   Gem.Vers. mit abgek. Prämienzahldauer, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1046',
    kurzBez: 'EI/5',
    bez: 'EI/5   Privatplan Klassik Intervall, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1060',
    kurzBez: 'EV/5',
    bez: 'EV/5   Kapitalversicherung auf Er- u. Ableben 2 Pers., Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1080',
    kurzBez: 'EGK/5',
    bez: 'EGK/5   Kollektivversicherung Er- u. Ableben, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV17']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1081',
    kurzBez: 'EGK3/5',
    bez: 'EGK3/5   Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1093',
    kurzBez: 'EPR/5',
    bez: 'EPR/5   Einmalerlag mit sofort beginnender Rente, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1095',
    kurzBez: 'EPE/5',
    bez: 'EPE/5   Erlebenstarif gegen Einmalerlag, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1101',
    kurzBez: 'EDD/3',
    bez: 'EDD/3   Dread Disease, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1102',
    kurzBez: 'EDK/3',
    bez: 'EDK/3   Dread Disease Kollektiv, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1107',
    kurzBez: 'ERA/3',
    bez: 'ERA/3   Abrufphase, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1114',
    kurzBez: 'EPLK3/3',
    bez: 'EPLK3/3   Erlebensversicherung § 3(1) Z15a, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1119',
    kurzBez: 'ER/3',
    bez: 'ER/3   Risikoversicherung, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1126',
    kurzBez: 'ERZ/3',
    bez: 'ERZ/3   Risiko-Zusatzversicherung, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1134',
    kurzBez: 'VEG/3',
    bez: 'VEG/3, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1136',
    kurzBez: 'VEV/3',
    bez: 'VEV/3, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1139',
    kurzBez: 'VEGE/3',
    bez: 'VEGE/3, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1140',
    kurzBez: 'EG/3',
    bez: 'EG/3   Kapitalversicherung auf Er- u. Ableben, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1141',
    kurzBez: 'EGV/3',
    bez: 'EGV/3   Gem.Vers. mit abgek. Prämienzahldauer, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1160',
    kurzBez: 'EV/3',
    bez: 'EV/3   Kapitalversicherung auf Er- u. Ableben 2 Pers., Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1170',
    kurzBez: 'ET/3',
    bez: 'ET/3   Kapitalvers. Er- u. Ableben zu festem Termin, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1179',
    kurzBez: 'EGKP/3',
    bez: 'EGKP/3   Kollektivversicherung Er- u. Ableben, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1180',
    kurzBez: 'EGK/3',
    bez: 'EGK/3   Kollektivversicherung Er- u. Ableben, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1181',
    kurzBez: 'EGK3/3',
    bez: 'EGK3/3   Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1191',
    kurzBez: 'EGE/3',
    bez: 'EGE/3   Kapitalvers. Er- u. Ableben Einmalerlag, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1193',
    kurzBez: 'EPR/3',
    bez: 'EPR/3   Einmalerlag mit sofort beginnender Rente, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1195',
    kurzBez: 'EPE/3',
    bez: 'EPE/3   Erlebenstarif gegen Einmalerlag, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1200',
    kurzBez: 'XL',
    bez: 'XL   Indexgebundene Lebensversicherung laufende Prämie',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1201',
    kurzBez: 'XE',
    bez: 'XE   Indexgebundene Lebensversicherung Einmalerlag',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1202',
    kurzBez: 'XBE',
    bez: 'XBE   Best of Life',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1203',
    kurzBez: 'XBE/2',
    bez: 'XBE/2   Best of Life II',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1204',
    kurzBez: 'XBE/3',
    bez: 'XBE/3   Best of Life III',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1205',
    kurzBez: 'XBE/4',
    bez: 'XBE/4   Best of Life IV',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1206',
    kurzBez: 'XBE/5',
    bez: 'XBE/5   Best of Life V - Wertstabil',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1210',
    kurzBez: 'ZLG',
    bez: 'ZLG - Indexgebundene Lebensversicherung gegen laufende Prämie',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1211',
    kurzBez: 'ZEG',
    bez: 'ZEG - Indexgebundene Lebensversicherung gegen Einmalerlag',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1212',
    kurzBez: 'ZL',
    bez: 'ZL - Indexgebundene Lebensversicherung gegen laufende Prämie',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1213',
    kurzBez: 'ZE',
    bez: 'ZE - Indexgebundene Lebensversicherung gegen Einmalerlag',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1214',
    kurzBez: 'ZLG/2',
    bez: 'ZLG/2 - Indexgebundene Lebensversicherung gegen laufende Prämie',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1215',
    kurzBez: 'ZEG/2',
    bez: 'ZEG/2 - Indexgebundene Lebensversicherung gegen Einmalerlag',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1216',
    kurzBez: 'ZL/2',
    bez: 'ZL/2 - Indexgebundene Lebensversicherung gegen laufende Prämie',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1217',
    kurzBez: 'ZE/2',
    bez: 'ZE/2 - Indexgebundene Lebensversicherung gegen Einmalerlag',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1220',
    kurzBez: 'PZV',
    bez: 'PZV   Prämienbegünstigte Zukunftsvorsorge',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: true,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1222',
    kurzBez: 'PZV/2',
    bez: 'PZV/2   Prämienbegünstigte Zukunftsvorsorge',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: true,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1223',
    kurzBez: 'PZV/3',
    bez: 'PZV/3   Prämienbegünstigte Zukunftsvorsorge',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: true,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1240',
    kurzBez: 'FLD',
    bez: 'FLD   FLV ohne Garantie - Dynamisch gg. lfd. Prämie',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1241',
    kurzBez: 'FED',
    bez: 'FED   FLV ohne Garantie - Dynamisch gg. Einmalerlag',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1242',
    kurzBez: 'FLA',
    bez: 'FLA   FLV ohne Garantie - Ausgewogen gg. lfd. Prämie',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1243',
    kurzBez: 'FEA',
    bez: 'FEA   FLV ohne Garantie - Ausgewogen gg. Einmalerlag',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1244',
    kurzBez: 'FLK',
    bez: 'FLK   FLV ohne Garantie - Klassisch gg. lfd. Prämie',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1245',
    kurzBez: 'FEK',
    bez: 'FEK   FLV ohne Garantie - Klassisch gg. Einmalerlag',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1246',
    kurzBez: 'FLG',
    bez: 'FLG   FLV mit Kapital- und Höchststandsgarantie gg. lfd. Prämie',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1247',
    kurzBez: 'FEG',
    bez: 'FEG   FLV mit Kapital- und Höchststandsgarantie gg. Einmalerlag',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1260',
    kurzBez: 'AILD',
    bez: 'AILD   FLV ohne Garantie - Dynamisch gg. lfd. Prämie',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1261',
    kurzBez: 'AIED',
    bez: 'AIED   FLV ohne Garantie - Dynamisch gg. Einmalerlag',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1262',
    kurzBez: 'AILA',
    bez: 'AILA   FLV ohne Garantie - Ausgewogen gg. lfd. Prämie',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1263',
    kurzBez: 'AIEA',
    bez: 'AIEA   FLV ohne Garantie - Ausgewogen gg. Einmalerlag',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1264',
    kurzBez: 'AILS',
    bez: 'AILS   FLV ohne Garantie - Solide gg. lfd. Prämie',
    risikoKlasse: 2,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1265',
    kurzBez: 'AIES',
    bez: 'AIES   FLV ohne Garantie - Solide gg. Einmalerlag',
    risikoKlasse: 2,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1266',
    kurzBez: 'AILG',
    bez: 'AILG   FLV mit zweifacher Höchststandsgarantie gg. lfd. Prämie',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1267',
    kurzBez: 'AIEG',
    bez: 'AIEG   FLV mit zweifacher Höchststandsgarantie gg. Einmalerlag',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1300',
    kurzBez: 'EPPL',
    bez: 'EPPL   prämienfreier EPL, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1301',
    kurzBez: 'EDD',
    bez: 'EDD   Dread Disease, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1302',
    kurzBez: 'EDK',
    bez: 'EDK   Dread Disease Kollektiv, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1314',
    kurzBez: 'EPLK3',
    bez: 'EPLK3   Erlebensversicherung § 3(1) Z15a, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1319',
    kurzBez: 'ER',
    bez: 'ER   Risikoversicherung, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1326',
    kurzBez: 'ERZ',
    bez: 'ERZ   Risiko-Zusatzversicherung, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1334',
    kurzBez: 'VEG',
    bez: 'VEG, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1336',
    kurzBez: 'VEV',
    bez: 'VEV, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1339',
    kurzBez: 'VEGE',
    bez: 'VEGE, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1340',
    kurzBez: 'EG',
    bez: 'EG   Kapitalversicherung auf Er- u. Ableben, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1341',
    kurzBez: 'EGV',
    bez: 'EGV   Gem.Vers. mit abgek. Prämienzahldauer, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1360',
    kurzBez: 'EV',
    bez: 'EV   Kapitalversicherung auf Er- u. Ableben 2 Pers., Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1369',
    kurzBez: 'ET1',
    bez: 'ET1, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1370',
    kurzBez: 'ET',
    bez: 'ET   Kapitalvers. Er- u. Ableben zu festem Termin, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1379',
    kurzBez: 'ESDP',
    bez: 'ESDP   Kollektivversicherung Er- u. Ableben, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1380',
    kurzBez: 'EGK',
    bez: 'EGK   Kollektivversicherung Er- u. Ableben, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1381',
    kurzBez: 'EGK3',
    bez: 'EGK3   Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1391',
    kurzBez: 'EGE',
    bez: 'EGE   Kapitalvers. Er- u. Ableben Einmalerlag, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1393',
    kurzBez: 'EPR',
    bez: 'EPR   Einmalerlag mit sofort beginnender Rente, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1394',
    kurzBez: 'EPL',
    bez: 'EPL   Erlebenstarif gegen laufende Prämienzahlung, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1395',
    kurzBez: 'EPE',
    bez: 'EPE   Erlebenstarif gegen Einmalerlag, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1399',
    kurzBez: 'ELT',
    bez: 'ELT   Anlageorientierte Erlebensversicherung, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1401',
    kurzBez: 'EDD/4',
    bez: 'EDD/4   Dread Disease, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1402',
    kurzBez: 'EPG/4',
    bez: 'EPG/4   Pflegeversicherung, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1403',
    kurzBez: 'EPGK/4',
    bez: 'EPGK/4   Kollektiv-Pflegeversicherung, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1414',
    kurzBez: 'EPLK3/4',
    bez: 'EPLK3/4   Erlebensversicherung § 3(1) Z15a, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1425',
    kurzBez: 'EBTE/4',
    bez: 'EBTE/4   Bestattungsvorsorge gegen Einmalerlag, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1434',
    kurzBez: 'VEG/4',
    bez: 'VEG/4, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1436',
    kurzBez: 'VEV/4',
    bez: 'VEV/4, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1439',
    kurzBez: 'VEGE/4',
    bez: 'VEGE/4, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1440',
    kurzBez: 'EG/4',
    bez: 'EG/4   Kapitalversicherung auf Er- u. Ableben, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1441',
    kurzBez: 'EGV/4',
    bez: 'EGV/4   Gem.Vers. mit abgek. Prämienzahldauer, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1446',
    kurzBez: 'EI/4',
    bez: 'EI/4   Privatplan Klassik Intervall, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1447',
    kurzBez: 'EIK/4',
    bez: 'EIK/4   Privatplan Klassik Intervall, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1460',
    kurzBez: 'EV/4',
    bez: 'EV/4   Kapitalversicherung auf Er- u. Ableben 2 Pers., Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1470',
    kurzBez: 'ET/4',
    bez: 'ET/4   Kapitalvers. Er- u. Ableben zu festem Termin, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1480',
    kurzBez: 'EGK/4',
    bez: 'EGK/4   Kollektivversicherung Er- u. Ableben, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1481',
    kurzBez: 'EGK3/4',
    bez: 'EGK3/4   Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1491',
    kurzBez: 'EGE/4',
    bez: 'EGE/4   Kapitalvers. Er- u. Ableben Einmalerlag, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1493',
    kurzBez: 'EPR/4',
    bez: 'EPR/4   Einmalerlag mit sofort beginnender Rente, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1494',
    kurzBez: 'PPM,',
    bez: 'PPM, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1495',
    kurzBez: 'EPE/4',
    bez: 'EPE/4   Erlebenstarif gegen Einmalerlag, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1501',
    kurzBez: 'EDD/2',
    bez: 'EDD/2   Dread Disease, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1502',
    kurzBez: 'EDK/2',
    bez: 'EDK/2   Dread Disease Kollektiv, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1507',
    kurzBez: 'ERA/2',
    bez: 'ERA/2   Abrufphase, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1514',
    kurzBez: 'EPLK3/2',
    bez: 'EPLK3/2   Erlebensversicherung § 3(1) Z15a, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1519',
    kurzBez: 'ER/2',
    bez: 'ER/2   Risikoversicherung, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1526',
    kurzBez: 'ERZ/2',
    bez: 'ERZ/2   Risiko-Zusatzversicherung, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1534',
    kurzBez: 'VEG/2',
    bez: 'VEG/2, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1536',
    kurzBez: 'VEV/2',
    bez: 'VEV/2, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1539',
    kurzBez: 'VEGE/2',
    bez: 'VEGE/2, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1540',
    kurzBez: 'EG/2',
    bez: 'EG/2   Kapitalversicherung auf Er- u. Ableben, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1541',
    kurzBez: 'EGV/2',
    bez: 'EGV/2   Gem.Vers. mit abgek. Prämienzahldauer, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1560',
    kurzBez: 'EV/2',
    bez: 'EV/2   Kapitalversicherung auf Er- u. Ableben 2 Pers., Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1570',
    kurzBez: 'ET/2',
    bez: 'ET/2   Kapitalvers. Er- u. Ableben zu festem Termin, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1579',
    kurzBez: 'EGKP/2',
    bez: 'EGKP/2   Kollektivversicherung Er- u. Ableben, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1580',
    kurzBez: 'EGK/2',
    bez: 'EGK/2   Kollektivversicherung Er- u. Ableben, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1581',
    kurzBez: 'EGK3/2',
    bez: 'EGK3/2   Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1591',
    kurzBez: 'EGE/2',
    bez: 'EGE/2   Kapitalvers. Er- u. Ableben Einmalerlag, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1593',
    kurzBez: 'EPR/2',
    bez: 'EPR/2   Einmalerlag mit sofort beginnender Rente, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1595',
    kurzBez: 'EPE/2',
    bez: 'EPE/2   Erlebenstarif gegen Einmalerlag, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1601',
    kurzBez: 'MDD',
    bez: 'MDD   Merkur Lebensschirm, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1602',
    kurzBez: 'MDK',
    bez: 'MDK   Merkur Lebensschirm Kollektiv, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1615',
    kurzBez: 'PLK96',
    bez: 'PLK96   Erlebenstarif gg. laufende Prämienzahlung, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1616',
    kurzBez: 'PEK96',
    bez: 'PEK96   Erlebenstarif gg. Einmalerlag, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1640',
    kurzBez: 'MG4',
    bez: 'MG4   Kapitalversicherung auf Er- u. Ableben, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1660',
    kurzBez: 'MV4',
    bez: 'MV4   Kapitalversicherung auf Er- u. Ableben 2 Personen, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1664',
    kurzBez: 'VMG4',
    bez: 'VMG4, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1670',
    kurzBez: 'MT4',
    bez: 'MT4   Kapitalversicherung Er- u. Ableben zu festem Termin, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1679',
    kurzBez: 'MGK4P',
    bez: 'MGK4P, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1680',
    kurzBez: 'MGK4',
    bez: 'MGK4, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1691',
    kurzBez: 'MGE4',
    bez: 'MGE4   Kapitalversicherung Er- u. Ableben Einmalerlag, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1695',
    kurzBez: 'PE96',
    bez: 'PE96   Erlebenstarif gegen Einmalerlag, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1699',
    kurzBez: 'MPI4',
    bez: 'MPI4, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1830',
    kurzBez: 'MA',
    bez: 'MA, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1831',
    kurzBez: 'KMA',
    bez: 'KMA, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1840',
    kurzBez: 'MG',
    bez: 'MG, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1841',
    kurzBez: 'MI',
    bez: 'MI 5/10, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1846',
    kurzBez: 'MI',
    bez: 'MI 2/10, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1851',
    kurzBez: 'MI',
    bez: 'MI 2/15, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1852',
    kurzBez: 'MIV',
    bez: 'MIV 2/15, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1853',
    kurzBez: 'MI',
    bez: 'MI 5/15, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1854',
    kurzBez: 'MIV',
    bez: 'MIV 5/15, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1856',
    kurzBez: 'MIA',
    bez: 'MIA 5/10, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1857',
    kurzBez: 'MIN',
    bez: 'MIN, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1860',
    kurzBez: 'MV',
    bez: 'MV, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1869',
    kurzBez: 'MT1',
    bez: 'MT1, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1870',
    kurzBez: 'MT',
    bez: 'MT, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1871',
    kurzBez: 'MB',
    bez: 'MB, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1872',
    kurzBez: 'MH',
    bez: 'MH, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1873',
    kurzBez: 'MHP',
    bez: 'MHP, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1875',
    kurzBez: 'ME',
    bez: 'ME, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1878',
    kurzBez: 'MAP',
    bez: 'MAP, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1879',
    kurzBez: 'MAT',
    bez: 'MAT, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1880',
    kurzBez: 'MGK',
    bez: 'MGK, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1881',
    kurzBez: 'MAK',
    bez: 'MAK, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1883',
    kurzBez: 'MVK',
    bez: 'MVK, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1884',
    kurzBez: 'VMG',
    bez: 'VMG, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1891',
    kurzBez: 'MGE',
    bez: 'MGE, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1894',
    kurzBez: 'MPM',
    bez: 'MPM, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1895',
    kurzBez: 'MPEM',
    bez: 'MPEM, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1897',
    kurzBez: 'MPEO',
    bez: 'MPEO, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1930',
    kurzBez: 'MAN',
    bez: 'MAN, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1931',
    kurzBez: 'MAV',
    bez: 'MAV, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1940',
    kurzBez: 'MGN',
    bez: 'MGN, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1941',
    kurzBez: 'MGV',
    bez: 'MGV, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1960',
    kurzBez: 'MVN',
    bez: 'MVN, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1968',
    kurzBez: 'KMT',
    bez: 'KMT, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1970',
    kurzBez: 'MTN',
    bez: 'MTN, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1979',
    kurzBez: 'MGK1',
    bez: 'MGK1, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1980',
    kurzBez: 'MGK*',
    bez: 'MGK*, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1983',
    kurzBez: 'MVK*',
    bez: 'MVK*, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1991',
    kurzBez: 'MGE*',
    bez: 'MGE*, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1992',
    kurzBez: 'MVE*',
    bez: 'MVE*, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1994',
    kurzBez: 'VMGN',
    bez: 'VMGN, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1996',
    kurzBez: 'VMVN',
    bez: 'VMVN, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11004',
    kurzBez: 'L12PG',
    bez: 'L12PG   Privatplan Meine Zukunft, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11005',
    kurzBez: 'L12PGV',
    bez: 'L12PGV   Privatplan Meine Zukunft mit abgekürzter Prämienzahlungsdauer, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11014',
    kurzBez: 'L12PLK3',
    bez: 'L12PLK3   Erlebensversicherung § 3(1) Z15a, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11018',
    kurzBez: 'L12ZPLK3',
    bez: 'L12ZPLK3   Erlebensversicherung § 3(1) Z15a, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11015',
    kurzBez: 'L12PLK',
    bez: 'L12PLK   Erlebenstarif gegen laufende Prämienzahlung, Kollektiv, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11016',
    kurzBez: 'L12PLV',
    bez: 'L12PLV   Erlebenstarif mit abgek. Prämienzahldauer, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11017',
    kurzBez: 'L13PLK3Z',
    bez: 'L13PLK3Z   Erlebensversicherung, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11019',
    kurzBez: 'L12R',
    bez: 'L12R   Risikoversicherung, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11024',
    kurzBez: 'L12BT',
    bez: 'L12BT   Bestattungsvorsorge gegen laufende Prämienzahlung, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11025',
    kurzBez: 'L12BTE',
    bez: 'L12BTE   Bestattungsvorsorge gegen Einmalerlag, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11034',
    kurzBez: 'L12VG',
    bez: 'L12VG, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11036',
    kurzBez: 'L12VV',
    bez: 'L12VV, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11039',
    kurzBez: 'L12VGE',
    bez: 'L12VGE, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11040',
    kurzBez: 'L12G',
    bez: 'L12G   Kapitalversicherung auf Er- u. Ableben, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11041',
    kurzBez: 'L12GV',
    bez: 'L12GV   Gem.Vers. mit abgek. Prämienzahldauer, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11046',
    kurzBez: 'L12I',
    bez: 'L12I   Privatplan Klassik Intervall, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11060',
    kurzBez: 'L12V',
    bez: 'L12V   Kapitalversicherung auf Er- u. Ableben 2 Pers., Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11070',
    kurzBez: 'L14T',
    bez: 'L14T   Kapitalvers. Er- u. Ableben zu festem Termin, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11080',
    kurzBez: 'L12GK',
    bez: 'L12GK   Kollektivversicherung Er- u. Ableben, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11081',
    kurzBez: 'L12GK3',
    bez: 'L12GK3   Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11085',
    kurzBez: 'L12ZGK3',
    bez: 'L12ZGK3   Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11082',
    kurzBez: 'L12GK3A',
    bez: 'L12GK3A   Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11086',
    kurzBez: 'L12ZGK3A',
    bez: 'L12ZGK3A  Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11083',
    kurzBez: 'L13GK3Z',
    bez: 'L13GK3Z   Er- und Ablebensversicherung, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11092',
    kurzBez: 'L12PL',
    bez: 'L12PL   Erlebenstarif gegen laufende Prämienzahlung, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11093',
    kurzBez: 'L12PR',
    bez: 'L12PR   Einmalerlag mit sofort beginnender Rente, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11095',
    kurzBez: 'L12PE',
    bez: 'L12PE   Erlebenstarif gegen Einmalerlag, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11104',
    kurzBez: 'L15PG',
    bez: 'L15PG   Dread Disease- und Pflegeversicherung, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11105',
    kurzBez: 'L15PGV',
    bez: 'L15PGV   Dread Disease- und Pflegeversicherung mit abgekürzter Prämienzahlungsdauer, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11114',
    kurzBez: 'L15PLK3',
    bez: 'L15PLK3   Klassische Erlebensversicherung § 3(1) Z15a, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11118',
    kurzBez: 'L15ZPLK3',
    bez: 'L15ZPLK3   Klassische Erlebensversicherung § 3(1) Z15a, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11115',
    kurzBez: 'L15PLK',
    bez: 'L15PLK   Klassische Erlebensversicherung gegen laufende Prämienzahlung, Kollektiv, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11116',
    kurzBez: 'L15PLV',
    bez: 'L15PLV   Klassische Erlebensversicherung mit abgek. Prämienzahldauer, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11117',
    kurzBez: 'L15PLK3Z',
    bez: 'L15PLK3Z   Klassische Erlebensversicherung, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11119',
    kurzBez: 'L15R',
    bez: 'L15R   Risikoversicherung, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11120',
    kurzBez: 'L15RK',
    bez: 'L15RK   Risikoversicherung (Kollektiv), Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11124',
    kurzBez: 'L15BT',
    bez: 'L15BT   Bestattungsvorsorge gegen laufende Prämienzahlung, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11125',
    kurzBez: 'L15BTE',
    bez: 'L15BTE   Bestattungsvorsorge gegen Einmalerlag, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11126',
    kurzBez: 'L15BTK',
    bez: 'L15BTK   Bestattungsvorsorge gegen laufende Prämienzahlung (Kollektiv), Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11134',
    kurzBez: 'L15VG',
    bez: 'L15VG, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11136',
    kurzBez: 'L15VV',
    bez: 'L15VV, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11139',
    kurzBez: 'L15VGE',
    bez: 'L15VGE, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11140',
    kurzBez: 'L15G',
    bez: 'L15G   Klassische Er- und Ablebensversicherung, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11141',
    kurzBez: 'L15GV',
    bez: 'L15GV   Klassische Er- und Ablebensversicherung mit abgek. Prämienzahldauer, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11146',
    kurzBez: 'L15I',
    bez: 'L15I   Klassische Erlebensversicherung Intervall, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11160',
    kurzBez: 'L15V',
    bez: 'L15V   Klassische Er- und Ablebensversicherung 2 Pers., Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11170',
    kurzBez: 'L15T',
    bez: 'L15T   Klassische Er- und Ablebensversicherung zu festem Termin, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11180',
    kurzBez: 'L15GK',
    bez: 'L15GK   Klassische Er- und Ablebensversicherung, Kollektiv, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11181',
    kurzBez: 'L15GK3',
    bez: 'L15GK3  Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11185',
    kurzBez: 'L15ZGK3',
    bez: 'L15ZGK3 Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11182',
    kurzBez: 'L15GK3A',
    bez: 'L15GK3A   Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11186',
    kurzBez: 'L15ZGK3A',
    bez: 'L15ZGK3A  Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11183',
    kurzBez: 'L15GK3Z',
    bez: 'L15GK3Z  Klassische Er- und Ablebensversicherung, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11192',
    kurzBez: 'L15PL',
    bez: 'L15PL   Klassische Erlebensversicherung gegen laufende Prämienzahlung, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11193',
    kurzBez: 'L15PR',
    bez: 'L15PR   Einmalerlag mit sofort beginnender Rente, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11195',
    kurzBez: 'L15PE',
    bez: 'L15PE   Klassische Erlebensversicherung gegen Einmalerlag, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11220',
    kurzBez: 'L15PZV',
    bez: 'L15PZV   Pensionsvorsorge',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11260',
    kurzBez: 'L12AILD',
    bez: 'L12AILD   FLV ohne Garantie - Dynamisch gg. lfd. Prämie',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11261',
    kurzBez: 'L12AIED',
    bez: 'L12AIED   FLV ohne Garantie - Dynamisch gg. Einmalerlag',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1', 'TFS_2']),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11262',
    kurzBez: 'L12AILA',
    bez: 'L12AILA   FLV ohne Garantie - Ausgewogen gg. lfd. Prämie',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11263',
    kurzBez: 'L12AIEA',
    bez: 'L12AIEA   FLV ohne Garantie - Ausgewogen gg. Einmalerlag',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1', 'TFS_2']),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11264',
    kurzBez: 'L12AILS',
    bez: 'L12AILS   FLV ohne Garantie - Solide gg. lfd. Prämie',
    risikoKlasse: 2,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11265',
    kurzBez: 'L12AIES',
    bez: 'L12AIES   FLV ohne Garantie - Solide gg. Einmalerlag',
    risikoKlasse: 2,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1', 'TFS_2']),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11266',
    kurzBez: 'L12AILG',
    bez: 'L12AILG   FLV mit zweifacher Höchststandsgarantie gg. lfd. Prämie',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11267',
    kurzBez: 'L12AIEG',
    bez: 'L12AIEG   FLV mit zweifacher Höchststandsgarantie gg. Einmalerlag',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11304',
    kurzBez: 'L16PG',
    bez: 'L16PG  Lebensstandard-Vorsorge, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11307',
    kurzBez: 'L16PGZ',
    bez: 'L16PGZ  Pflegezusatzversicherung, Rechnungszins 1,00%',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11314',
    kurzBez: 'L16PLK3',
    bez: 'L16PLK3  Klassische Erlebensversicherung § 3(1) Z15a, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11318',
    kurzBez: 'L16ZPLK3',
    bez: 'L16ZPLK3  Klassische Erlebensversicherung § 3(1) Z15a, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11315',
    kurzBez: 'L16PLK',
    bez: 'L16PLK  Klassische Erlebensversicherung gegen laufende Prämienzahlung, Kollektiv, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11319',
    kurzBez: 'L16R',
    bez: 'L16R  Risikoversicherung, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11320',
    kurzBez: 'L16RK',
    bez: 'L16RK  Risikoversicherung (Kollektiv), Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11321',
    kurzBez: 'L16RNR',
    bez: 'L16RNR  Risikoversicherung für Nichtraucher, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16NR']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11322',
    kurzBez: 'L16RR',
    bez: 'L16RR  Risikoversicherung für Raucher, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11324',
    kurzBez: 'L16BT',
    bez: 'L16BT  Bestattungsvorsorge gegen laufende Prämienzahlung, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11325',
    kurzBez: 'L16BTE',
    bez: 'L16BTE  Bestattungsvorsorge gegen Einmalerlag, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11326',
    kurzBez: 'L16BTK',
    bez: 'L16BTK  Bestattungsvorsorge gegen laufende Prämienzahlung (Kollektiv), Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11327',
    kurzBez: 'L16BT/2',
    bez: 'L16BT/2  Bestattungsvorsorge gegen laufende Prämienzahlung, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11328',
    kurzBez: 'L16BTE/2',
    bez: 'L16BTE/2  Bestattungsvorsorge gegen Einmalerlag, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11334',
    kurzBez: 'L16VG',
    bez: 'L16VG  Ablaufverlängerung einer Versicherung auf den Er- und Ablebensfall gegen laufende Prämienzahlung, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11336',
    kurzBez: 'L16VV',
    bez: 'L16VV  Ablaufverlängerung einer Versicherung auf den Er- und Ablebensfall für 2 Personen gegen laufende Prämienzahlung, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11339',
    kurzBez: 'L16VGE',
    bez: 'L16VGE  Ablaufverlängerung einer Versicherung auf den Er- und Ablebensfall gegen Einmalerlag, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11340',
    kurzBez: 'L16G',
    bez: 'L16G  Klassische Er- und Ablebensversicherung, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11342',
    kurzBez: 'L16G/2',
    bez: 'L16G/2  Klassische Er- und Ablebensversicherung mit variabler Ablebenssumme, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11346',
    kurzBez: 'L16ZGE',
    bez: 'L16ZGE  Klassische Er- und Ablebensversicherung gegen Einmalerlag, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11360',
    kurzBez: 'L16V',
    bez: 'L16V  Klassische Er- und Ablebensversicherung 2 Pers., Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11366',
    kurzBez: 'L16ZVE',
    bez: 'L16ZVE  Klassische Er- und Ablebensversicherung 2 Pers. gegen Einmalerlag, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11370',
    kurzBez: 'L16T',
    bez: 'L16T  Klassische Er- und Ablebensversicherung zu festem Termin, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11376',
    kurzBez: 'L16ZTE',
    bez: 'L16ZTE  Klassische Er- und Ablebensversicherung zu festem Termin gegen Einmalerlag, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11380',
    kurzBez: 'L16GK',
    bez: 'L16GK  Klassische Er- und Ablebensversicherung, Kollektiv, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11381',
    kurzBez: 'L16GK3',
    bez: 'L16GK3  Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11385',
    kurzBez: 'L16ZGK3',
    bez: 'L16ZGK3 Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11382',
    kurzBez: 'L16GK3A',
    bez: 'L16GK3A  Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11386',
    kurzBez: 'L16ZGK3A',
    bez: 'L16ZGK3A  Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11392',
    kurzBez: 'L16PL',
    bez: 'L16PL  Klassische Erlebensversicherung gegen laufende Prämienzahlung, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11393',
    kurzBez: 'L16PR',
    bez: 'L16PR  Einmalerlag mit sofort beginnender Rente, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11395',
    kurzBez: 'L16PE',
    bez: 'L16PE  Klassische Erlebensversicherung gegen Einmalerlag, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11396',
    kurzBez: 'L16ZPE',
    bez: 'L16ZPE  Klassische Erlebensversicherung gegen Einmalerlag, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11404',
    kurzBez: 'L17PG',
    bez: 'L17PG  Lebensstandard-Vorsorge, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11604',
    kurzBez: 'L22PG',
    bez: 'L22PG  Lebensstandard-Vorsorge, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11505',
    kurzBez: 'L20ZPG',
    bez: 'L20ZPG  Lebensstandard-Vorsorge, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16', 'ERH']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11605',
    kurzBez: 'L22ZPG',
    bez: 'L22ZPG  Lebensstandard-Vorsorge, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16', 'ERH']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11506',
    kurzBez: 'L20ZPGE',
    bez: 'L20ZPGE  Lebensstandard-Vorsorge, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11606',
    kurzBez: 'L22ZPGE',
    bez: 'L22ZPGE  Lebensstandard-Vorsorge, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11407',
    kurzBez: 'L17PGZ',
    bez: 'L17PGZ  Pflegezusatzversicherung, Rechnungszins 0,50%',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11607',
    kurzBez: 'L22PGZ',
    bez: 'L22PGZ  Pflegezusatzversicherung, Rechnungszins 0,00%',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11414',
    kurzBez: 'L17PLK3',
    bez: 'L17PLK3  Klassische Erlebensversicherung § 3(1) Z15a, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11614',
    kurzBez: 'L22PLK3',
    bez: 'L22PLK3  Klassische Erlebensversicherung § 3(1) Z15a, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11512',
    kurzBez: 'L20ZPLK3',
    bez: 'L20ZPLK3  Klassische Erlebensversicherung § 3(1) Z15a, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11612',
    kurzBez: 'L22ZPLK3',
    bez: 'L22ZPLK3  Klassische Erlebensversicherung § 3(1) Z15a, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11415',
    kurzBez: 'L17PLK',
    bez: 'L17PLK  Klassische Erlebensversicherung gegen laufende Prämienzahlung, Kollektiv, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11615',
    kurzBez: 'L22PLK',
    bez: 'L22PLK  Klassische Erlebensversicherung gegen laufende Prämienzahlung, Kollektiv, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11513',
    kurzBez: 'L20ZPLK',
    bez: 'L20ZPLK  Klassische Erlebensversicherung gegen laufende Prämienzahlung, Kollektiv, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11613',
    kurzBez: 'L22ZPLK',
    bez: 'L22ZPLK  Klassische Erlebensversicherung gegen laufende Prämienzahlung, Kollektiv, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11416',
    kurzBez: 'L17FNR',
    bez: 'L17FNR  Risikoversicherung für Nichtraucher mit fallender Ablebensleistung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16NR']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11616',
    kurzBez: 'L22FNR',
    bez: 'L22FNR  Risikoversicherung für Nichtraucher mit fallender Ablebensleistung, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16NR']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11417',
    kurzBez: 'L17FR',
    bez: 'L17FR  Risikoversicherung für Raucher mit fallender Ablebensleistung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11617',
    kurzBez: 'L22FR',
    bez: 'L22FR  Risikoversicherung für Raucher mit fallender Ablebensleistung, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11418',
    kurzBez: 'L17FVNR',
    bez: 'L17FVNR  Risikoversicherung für Nichtraucher für 2 Personen mit fallender Ablebensleistung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16NR']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11618',
    kurzBez: 'L22FVNR',
    bez: 'L22FVNR  Risikoversicherung für Nichtraucher für 2 Personen mit fallender Ablebensleistung, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16NR']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11419',
    kurzBez: 'L17FVR',
    bez: 'L17FVR  Risikoversicherung für Raucher für 2 Personen mit fallender Ablebensleistung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11619',
    kurzBez: 'L22FVR',
    bez: 'L22FVR  Risikoversicherung für Raucher für 2 Personen mit fallender Ablebensleistung, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11420',
    kurzBez: 'L17RK',
    bez: 'L17RK  Risikoversicherung (Kollektiv), Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11620',
    kurzBez: 'L22RK',
    bez: 'L22RK  Risikoversicherung (Kollektiv), Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11421',
    kurzBez: 'L17RNR',
    bez: 'L17RNR  Risikoversicherung für Nichtraucher, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16NR']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11621',
    kurzBez: 'L22RNR',
    bez: 'L22RNR  Risikoversicherung für Nichtraucher, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16NR']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11422',
    kurzBez: 'L17RR',
    bez: 'L17RR  Risikoversicherung für Raucher, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11622',
    kurzBez: 'L22RR',
    bez: 'L22RR  Risikoversicherung für Raucher, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11424',
    kurzBez: 'L17BT',
    bez: 'L17BT  Bestattungsvorsorge gegen laufende Prämienzahlung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11624',
    kurzBez: 'L22BT',
    bez: 'L22BT  Bestattungsvorsorge gegen laufende Prämienzahlung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11627',
    kurzBez: 'L22BTS',
    bez: 'L22BTS  Bestattungsvorsorge gegen laufende Prämienzahlung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['BTS22']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11526',
    kurzBez: 'L20ZBT',
    bez: 'L20ZBT  Bestattungsvorsorge gegen laufende Prämienzahlung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11626',
    kurzBez: 'L22ZBT',
    bez: 'L22ZBT  Bestattungsvorsorge gegen laufende Prämienzahlung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11628',
    kurzBez: 'L22ZBTS',
    bez: 'L22ZBTS  Bestattungsvorsorge gegen laufende Prämienzahlung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['BTS22']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11425',
    kurzBez: 'L17BTE',
    bez: 'L17BTE  Bestattungsvorsorge gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11434',
    kurzBez: 'L17VG',
    bez: 'L17VG  Ablaufverlängerung einer Versicherung auf den Er- und Ablebensfall gegen laufende Prämienzahlung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11634',
    kurzBez: 'L22VG',
    bez: 'L22VG  Ablaufverlängerung einer Versicherung auf den Er- und Ablebensfall gegen laufende Prämienzahlung, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11436',
    kurzBez: 'L17VV',
    bez: 'L17VV  Ablaufverlängerung einer Versicherung auf den Er- und Ablebensfall für 2 Personen gegen laufende Prämienzahlung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11636',
    kurzBez: 'L22VV',
    bez: 'L22VV  Ablaufverlängerung einer Versicherung auf den Er- und Ablebensfall für 2 Personen gegen laufende Prämienzahlung, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11567',
    kurzBez: 'L17VVE/2',
    bez: 'L17VVE/2  Ablaufverlängerung einer Versicherung auf den Er- und Ablebensfall für 2 Personen gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11667',
    kurzBez: 'L22VVE',
    bez: 'L22VVE  Ablaufverlängerung einer Versicherung auf den Er- und Ablebensfall für 2 Personen gegen Einmalerlag, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11439',
    kurzBez: 'L17VGE',
    bez: 'L17VGE  Ablaufverlängerung einer Versicherung auf den Er- und Ablebensfall gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11539',
    kurzBez: 'L17VGE/2',
    bez: 'L17VGE/2  Ablaufverlängerung einer Versicherung auf den Er- und Ablebensfall gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11639',
    kurzBez: 'L22VGE',
    bez: 'L22VGE  Ablaufverlängerung einer Versicherung auf den Er- und Ablebensfall gegen Einmalerlag, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11440',
    kurzBez: 'L17G',
    bez: 'L17G  Klassische Er- und Ablebensversicherung mit variabler Ablebenssumme, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11640',
    kurzBez: 'L22G',
    bez: 'L22G  Klassische Er- und Ablebensversicherung mit variabler Ablebenssumme, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11446',
    kurzBez: 'L17ZGE',
    bez: 'L17ZGE  Klassische Er- und Ablebensversicherung gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11447',
    kurzBez: 'L17ZGE/2',
    bez: 'L17ZGE/2  Klassische Er- und Ablebensversicherung gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11546',
    kurzBez: 'L20ZGE',
    bez: 'L20ZGE  Klassische Er- und Ablebensversicherung gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11646',
    kurzBez: 'L22ZGE',
    bez: 'L22ZGE  Klassische Er- und Ablebensversicherung gegen Einmalerlag, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11460',
    kurzBez: 'L17V',
    bez: 'L17V  Klassische Er- und Ablebensversicherung 2 Pers., Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11660',
    kurzBez: 'L22V',
    bez: 'L22V  Klassische Er- und Ablebensversicherung 2 Pers., Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11466',
    kurzBez: 'L17ZVE',
    bez: 'L17ZVE  Klassische Er- und Ablebensversicherung 2 Pers. gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11467',
    kurzBez: 'L17ZVE/2',
    bez: 'L17ZVE/2  Klassische Er- und Ablebensversicherung 2 Pers. gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11566',
    kurzBez: 'L20ZVE',
    bez: 'L20ZVE  Klassische Er- und Ablebensversicherung 2 Pers. gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11666',
    kurzBez: 'L22ZVE',
    bez: 'L22ZVE  Klassische Er- und Ablebensversicherung 2 Pers. gegen Einmalerlag, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11470',
    kurzBez: 'L17T',
    bez: 'L17T  Klassische Er- und Ablebensversicherung zu festem Termin, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11670',
    kurzBez: 'L22T',
    bez: 'L22T  Klassische Er- und Ablebensversicherung zu festem Termin, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11476',
    kurzBez: 'L17ZTE',
    bez: 'L17ZTE  Klassische Er- und Ablebensversicherung zu festem Termin gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11477',
    kurzBez: 'L17ZTE/2',
    bez: 'L17ZTE/2  Klassische Er- und Ablebensversicherung zu festem Termin gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11576',
    kurzBez: 'L20ZTE',
    bez: 'L20ZTE  Klassische Er- und Ablebensversicherung zu festem Termin gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11676',
    kurzBez: 'L22ZTE',
    bez: 'L22ZTE  Klassische Er- und Ablebensversicherung zu festem Termin gegen Einmalerlag, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11480',
    kurzBez: 'L17GK',
    bez: 'L17GK  Klassische Er- und Ablebensversicherung, Kollektiv, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11680',
    kurzBez: 'L22GK',
    bez: 'L22GK  Klassische Er- und Ablebensversicherung, Kollektiv, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11585',
    kurzBez: 'L20ZGK',
    bez: 'L20ZGK  Klassische Er- und Ablebensversicherung, Kollektiv, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16', 'ERH']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11685',
    kurzBez: 'L22ZGK',
    bez: 'L22ZGK  Klassische Er- und Ablebensversicherung, Kollektiv, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16', 'ERH']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11481',
    kurzBez: 'L17GK3',
    bez: 'L17GK3  Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11681',
    kurzBez: 'L22GK3',
    bez: 'L22GK3  Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11586',
    kurzBez: 'L20ZGK3',
    bez: 'L20ZGK3  Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3', 'ERH']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11686',
    kurzBez: 'L22ZGK3',
    bez: 'L22ZGK3  Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3', 'ERH']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11687',
    kurzBez: 'L22ZGK3A',
    bez: 'L22ZGK3A Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3', 'ERH']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11482',
    kurzBez: 'L17GK3A',
    bez: 'L17GK3A  Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11486',
    kurzBez: 'L17ZGK3A',
    bez: 'L17TGK3A  Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11682',
    kurzBez: 'L22GK3A',
    bez: 'L22GK3A  Klassische Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11492',
    kurzBez: 'L17PL',
    bez: 'L17PL  Klassische Erlebensversicherung gegen laufende Prämienzahlung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11692',
    kurzBez: 'L22PL',
    bez: 'L22PL  Klassische Erlebensversicherung gegen laufende Prämienzahlung, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11493',
    kurzBez: 'L17PR',
    bez: 'L17PR  Einmalerlag mit sofort beginnender Rente, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: false
    }
  },
  {
    tarifNr: '11495',
    kurzBez: 'L17PE',
    bez: 'L17PE  Klassische Erlebensversicherung gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11496',
    kurzBez: 'L17ZPE',
    bez: 'L17ZPE  Klassische Erlebensversicherung gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11498',
    kurzBez: 'L17ZPE/2',
    bez: 'L17ZPE/2  Klassische Erlebensversicherung gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11596',
    kurzBez: 'L20ZPE',
    bez: 'L20ZPE  Klassische Erlebensversicherung gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11696',
    kurzBez: 'L22ZPE',
    bez: 'L22ZPE  Klassische Erlebensversicherung gegen Einmalerlag, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11560',
    kurzBez: 'L12AILD/2',
    bez: 'L12AILD/2   FLV ohne Garantie - Dynamisch gg. lfd. Prämie',
    risikoKlasse: 4,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1', 'TFS_1']),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11552',
    kurzBez: 'L20GLL',
    bez: 'L20GLL   FLV ohne Garantie - Dynamisch gg. lfd. Prämie',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['GL20', 'GL20TFS_1']),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11652',
    kurzBez: 'L22GLL',
    bez: 'L22GLL   FLV ohne Garantie - Dynamisch gg. lfd. Prämie',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['GL20', 'GL20TFS_1']),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11555',
    kurzBez: 'L20GLD',
    bez: 'L20GLD   FLV ohne Garantie - Dynamisch gg. lfd. Prämie',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['GL20', 'GL20TFS_1']),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11655',
    kurzBez: 'L22GLD',
    bez: 'L22GLD   FLV ohne Garantie - Dynamisch gg. lfd. Prämie',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['GL20', 'GL20TFS_1']),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11562',
    kurzBez: 'L12AILA/2',
    bez: 'L12AILA/2   FLV ohne Garantie - Ausgewogen gg. lfd. Prämie',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1', 'TFS_1']),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11554',
    kurzBez: 'L20GLA',
    bez: 'L20GLA   FLV ohne Garantie - Ausgewogen gg. lfd. Prämie',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['GL20', 'GL20TFS_1']),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11654',
    kurzBez: 'L22GLA',
    bez: 'L22GLA   FLV ohne Garantie - Ausgewogen gg. lfd. Prämie',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['GL20', 'GL20TFS_1']),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11564',
    kurzBez: 'L12AILS/2',
    bez: 'L12AILS/2   FLV ohne Garantie - Solide gg. lfd. Prämie',
    risikoKlasse: 2,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV TGP 1', 'TFS_1']),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11553',
    kurzBez: 'L20GLS',
    bez: 'L20GLS   FLV ohne Garantie - Solide gg. lfd. Prämie',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['GL20', 'GL20TFS_1']),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11653',
    kurzBez: 'L22GLS',
    bez: 'L22GLS   FLV ohne Garantie - Solide gg. lfd. Prämie',
    risikoKlasse: 3,
    fragenDefs: {
      gesundheitsfragenG: new Set(['GL20', 'GL20TFS_1']),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1024',
    kurzBez: 'EBT/5',
    bez: 'EBT/5   Bestattungsvorsorge gegen laufende Prämienzahlung, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1092',
    kurzBez: 'EPL/5',
    bez: 'EPL/5   Erlebenstarif gegen laufende Prämienzahlung, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11008',
    kurzBez: 'L12RO',
    bez: 'L12RO   Rentenoption - Barwert einer Leibrente, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1416',
    kurzBez: 'EPLV/4',
    bez: 'EPLV/4   Erlebenstarif mit abgek. Prämienzahldauer, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11394',
    kurzBez: 'L16ZPL',
    bez: 'L16ZPL  Klassische Erlebensversicherung gegen laufende Prämienzahlung, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11399',
    kurzBez: 'L16VPL',
    bez: 'L16VPL  Ablaufverlängerung einer Erlebensversicherung gegen laufende Prämienzahlung, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11451',
    kurzBez: 'L17GBE',
    bez: 'L17GBE   Klassische Er- und Ablebensversicherung gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1230',
    kurzBez: 'MXL',
    bez: 'MXL',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1659',
    kurzBez: 'MV4*',
    bez: 'MV4*, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1099',
    kurzBez: 'VEPL/5',
    bez: 'VEPL/5, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11197',
    kurzBez: 'L15VPE',
    bez: 'L15VPE, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11308',
    kurzBez: 'L16RO',
    bez: 'L16RO  Rentenoption - Barwert einer Leibrente, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11375',
    kurzBez: 'L16ZT',
    bez: 'L16ZT  Klassische Er- und Ablebensversicherung zu festem Termin, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1232',
    kurzBez: 'MXVTG',
    bez: 'MXVTG',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1515',
    kurzBez: 'EPLK/2',
    bez: 'EPLK/2   Erlebenstarif gegen laufende Prämienzahlung, Kollektiv, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1641',
    kurzBez: 'MGV4',
    bez: 'MGV4   Gem. Versicherung mit abgek. Prämienzahldauer, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1694',
    kurzBez: 'PL96',
    bez: 'PL96   Erlebenstarif gegen laufende Prämienzahlung, Rechnungszins 4,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1082',
    kurzBez: 'EGK3/5A',
    bez: 'EGK3/5A   Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11408',
    kurzBez: 'L17RO',
    bez: 'L17RO  Rentenoption - Barwert einer Leibrente, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11608',
    kurzBez: 'L22RO',
    bez: 'L22RO  Rentenoption - Barwert einer Leibrente, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1233',
    kurzBez: 'MXE',
    bez: 'MXE',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1315',
    kurzBez: 'EPLK',
    bez: 'EPLK   Erlebenstarif gegen laufende Prämienzahlung, Kollektiv, Rechnungszins 3,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1819',
    kurzBez: 'MRN',
    bez: 'MRN, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1981',
    kurzBez: 'MAK*',
    bez: 'MAK*, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11199',
    kurzBez: 'L15VPL',
    bez: 'L15VPL, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11351',
    kurzBez: 'L16GBE',
    bez: 'L16GBE   Klassische Er- und Ablebensversicherung gegen Einmalerlag, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11442',
    kurzBez: '--',
    bez: '--keine Bezeichnung--',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11465',
    kurzBez: 'L17ZV',
    bez: 'L17ZV  Klassische Er- und Ablebensversicherung 2 Pers., Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11464',
    kurzBez: 'L17ZV/2',
    bez: 'L17ZV/2  Klassische Er- und Ablebensversicherung 2 Pers., Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11565',
    kurzBez: 'L20ZV',
    bez: 'L20ZV  Klassische Er- und Ablebensversicherung 2 Pers., Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16', 'ERH']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11665',
    kurzBez: 'L22ZV',
    bez: 'L22ZV  Klassische Er- und Ablebensversicherung 2 Pers., Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16', 'ERH']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11597',
    kurzBez: 'L17VPE/2',
    bez: 'L17VPE/2  Ablaufverlängerung einer Erlebensversicherung gegen Einmalerlag, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11697',
    kurzBez: 'L22VPE',
    bez: 'L22VPE  Ablaufverlängerung einer Erlebensversicherung gegen Einmalerlag, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1196',
    kurzBez: 'EPL0/3',
    bez: 'EPL0/3, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1235',
    kurzBez: 'MBL',
    bez: 'MBL',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1497',
    kurzBez: 'VEPE/4R',
    bez: 'VEPE/4R, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1016',
    kurzBez: 'EPLV/5',
    bez: 'EPLV/5   Erlebenstarif mit abgek. Prämienzahldauer, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11108',
    kurzBez: 'L15RO',
    bez: 'L15RO   Rentenoption - Barwert einer Leibrente, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1115',
    kurzBez: 'EPLK/3',
    bez: 'EPLK/3   Erlebenstarif gegen laufende Prämienzahlung, Kollektiv, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11365',
    kurzBez: 'L16ZV',
    bez: 'L16ZV  Klassische Er- und Ablebensversicherung 2 Pers., Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11475',
    kurzBez: 'L17ZT',
    bez: 'L17ZT  Klassische Er- und Ablebensversicherung zu festem Termin, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11474',
    kurzBez: 'L17ZT/2',
    bez: 'L17ZT/2  Klassische Er- und Ablebensversicherung zu festem Termin, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11575',
    kurzBez: 'L20ZT',
    bez: 'L20ZT  Klassische Er- und Ablebensversicherung zu festem Termin, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16', 'ERH']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11675',
    kurzBez: 'L22ZT',
    bez: 'L22ZT  Klassische Er- und Ablebensversicherung zu festem Termin, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16', 'ERH']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1234',
    kurzBez: 'MXVT',
    bez: 'MXVT',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1424',
    kurzBez: 'EBT/4',
    bez: 'EBT/4   Bestattungsvorsorge gegen laufende Prämienzahlung, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1829',
    kurzBez: 'Mrz 02',
    bez: 'MRZ2, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11345',
    kurzBez: 'L16ZG',
    bez: 'L16ZG  Klassische Er- und Ablebensversicherung mit variabler Ablebenssumme, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1482',
    kurzBez: 'EGK3/4A',
    bez: 'EGK3/4A   Er- und Ablebensversicherung § 3(1) Z15a, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV PAR 3']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: true,
      treuhaenderFrage: false,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1594',
    kurzBez: 'EPL/2',
    bez: 'EPL/2   Erlebenstarif gegen laufende Prämienzahlung, Rechnungszins 2,75%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1015',
    kurzBez: 'EPLK/5',
    bez: 'EPLK/5   Erlebenstarif gegen laufende Prämienzahlung, Kollektiv, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1097',
    kurzBez: 'VEPE/5',
    bez: 'VEPE/5, Rechnungszins 2,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11099',
    kurzBez: 'L12VPL',
    bez: 'L12VPL, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11151',
    kurzBez: 'L15GBE',
    bez: 'L15GBE   Klassische Er- und Ablebensversicherung gegen Einmalerlag, Rechnungszins 1,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11397',
    kurzBez: 'L16VPE',
    bez: 'L16VPE  Ablaufverlängerung einer Erlebensversicherung gegen Einmalerlag, Rechnungszins 1,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1194',
    kurzBez: 'EPL/3',
    bez: 'EPL/3   Erlebenstarif gegen laufende Prämienzahlung, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1417',
    kurzBez: 'EPLVK/4',
    bez: 'EPLVK/4   Erlebenstarif mit abgek. Prämienzahldauer, Kollektiv, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1826',
    kurzBez: 'MRZ',
    bez: 'MRZ, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11494',
    kurzBez: 'L17ZPL',
    bez: 'L17ZPL  Klassische Erlebensversicherung gegen laufende Prämienzahlung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11491',
    kurzBez: 'L17ZPL/2',
    bez: 'L17ZPL/2  Klassische Erlebensversicherung gegen laufende Prämienzahlung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11594',
    kurzBez: 'L20ZPL',
    bez: 'L20ZPL  Klassische Erlebensversicherung gegen laufende Prämienzahlung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11694',
    kurzBez: 'L22ZPL',
    bez: 'L22ZPL  Klassische Erlebensversicherung gegen laufende Prämienzahlung, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11499',
    kurzBez: 'L17VPL',
    bez: 'L17VPL  Ablaufverlängerung einer Erlebensversicherung gegen laufende Prämienzahlung, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11699',
    kurzBez: 'L22VPL',
    bez: 'L22VPL  Ablaufverlängerung einer Erlebensversicherung gegen laufende Prämienzahlung, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1199',
    kurzBez: 'VEPL0/3',
    bez: 'VEPL0/3, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1231',
    kurzBez: 'MXEG',
    bez: 'MXEG',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1415',
    kurzBez: 'EPLK/4',
    bez: 'EPLK/4   Erlebenstarif gegen laufende Prämienzahlung, Kollektiv, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1820',
    kurzBez: 'MR',
    bez: 'MR, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1939',
    kurzBez: 'MGN1',
    bez: 'MGN1, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11097',
    kurzBez: 'L12VPE',
    bez: 'L12VPE, Rechnungszins 1,75%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11445',
    kurzBez: 'L17ZG',
    bez: 'L17ZG  Klassische Er- und Ablebensversicherung mit variabler Ablebenssumme, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11444',
    kurzBez: 'L17ZG/2',
    bez: 'L17ZG/2  Klassische Er- und Ablebensversicherung mit variabler Ablebenssumme, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11545',
    kurzBez: 'L20ZG',
    bez: 'L20ZG  Klassische Er- und Ablebensversicherung mit variabler Ablebenssumme, Rechnungszins 0,50%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16', 'ERH']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '11645',
    kurzBez: 'L22ZG',
    bez: 'L22ZG  Klassische Er- und Ablebensversicherung mit variabler Ablebenssumme, Rechnungszins 0,00%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16', 'ERH']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1492',
    kurzBez: 'EPL/4',
    bez: 'EPL/4   Erlebenstarif gegen laufende Prämienzahlung, Rechnungszins 2,25%, Gewinnverband A',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1822',
    kurzBez: 'MR1',
    bez: 'MR1, Rechnungszins 3,00%, Gewinnverband A',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1896',
    kurzBez: 'MPO',
    bez: '--keine Bezeichnung--',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1892',
    kurzBez: 'MVE',
    bez: '--keine Bezeichnung--',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1911',
    kurzBez: 'MGE11',
    bez: '--keine Bezeichnung--',
    risikoKlasse: 1,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1886',
    kurzBez: 'VMV',
    bez: '--keine Bezeichnung--',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1611',
    kurzBez: 'MGE41',
    bez: 'MGE41',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1307',
    kurzBez: 'ERA',
    bez: 'ERA',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1842',
    kurzBez: 'MIV510',
    bez: 'MIV510',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1845',
    kurzBez: 'MI 310',
    bez: 'MI 310',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1848',
    kurzBez: 'MIV210',
    bez: 'MIV210',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(['LV16']),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    tarifNr: '1316',
    kurzBez: 'EPEK',
    bez: 'EPEK',
    risikoKlasse: 0,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: false,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  }
];
